var map = {
	"./nav-assets-active.png": "dc0c",
	"./nav-big-screen-active.png": "27de",
	"./nav-maintenance-active.png": "0b81",
	"./nav-message-active.png": "41d6",
	"./nav-performance-analysis-active.png": "039d",
	"./nav-report-active.png": "cc3c",
	"./nav-set-active.png": "2115",
	"./nav-work-active.png": "8dfc",
	"./nav-workbench-active.png": "ac61"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0c25";